import React from "react";

// Renders admin/PDF question text preserving <u>/<b>/<em>/<br> and newlines.
// Escapes everything else to avoid injection.
function toSafeHtml(text) {
  let s = (text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  // restore a small whitelist of formatting tags
  s = s.replace(/&lt;(\/?)(u|b|strong|em|i|sup|sub|br)\s*\/?&gt;/gi, "<$1$2>");
  s = s.replace(/\r?\n/g, "<br>");
  return s;
}

export default function QuestionText({ text, className = "" }) {
  return (
    <span
      className={`question-text whitespace-pre-wrap ${className}`}
      dangerouslySetInnerHTML={{ __html: toSafeHtml(text) }}
    />
  );
}
